export const queryKey = {
    chapters: () => ['chapters'],
};
